// War Room Planning: sortable/filterable table of every stocked ASIN with purchase-planning
// columns, tags, and a flag toggle. Consumes GET /api/war-room/planning (Task 8's
// ScorecardService.getPlanningRows()) via ApiClient, matching WarRoom.js's fetch pattern.
import React, { useCallback, useEffect, useState } from 'react';
import ApiClient from '../../utils/ApiClient';
import PlanningTable from './PlanningTable';
import WarRoomTabs from './WarRoomTabs';

function PlanningPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPlanning = useCallback(async () => {
        try {
            const response = await ApiClient.get('/api/war-room/planning');
            setData(response.data);
            setError(null);
        } catch (err) {
            console.error('Error fetching war room planning rows:', err);
            setError('Failed to load the planning table. Please try again.');
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        fetchPlanning().finally(() => setLoading(false));
    }, [fetchPlanning]);

    if (loading) {
        return (
            <div className="flex items-center justify-center py-24">
                <svg className="animate-spin h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
            </div>
        );
    }

    const rows = data?.rows || [];

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900">War Room Planning</h1>
                <p className="text-sm text-gray-500">
                    Purchase-planning view of every stocked ASIN — scorecard date: {data?.scorecardDate || '—'}
                </p>
            </div>

            <WarRoomTabs active="Planning" />

            {error && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-sm text-red-800">
                    {error}
                </div>
            )}

            <PlanningTable rows={rows} sellerNames={data?.sellerNames || {}} />
        </div>
    );
}

export default PlanningPage;
